import { gsap, SplitText } from './gsap';
import { debounce } from '../helpers/debounce';
import { revealUp } from './revealUp';
import { revealSkew } from './revealSkew';
import highlight from './highlight';

const splitReveal = () => {
  const splitContent = document.querySelectorAll('.split-reveal h1, .split-reveal h2, .split-reveal h3, h1.split-reveal, h2.split-reveal, h3.split-reveal');
  const splitSkewContent = document.querySelectorAll('.split-reveal-skew h1, .split-reveal-skew h2, .split-reveal-skew h3, h1.split-reveal-skew, h2.split-reveal-skew, h3.split-reveal-skew');
  const windowWidth = window.innerWidth;

  if (splitContent.length > 0 || splitSkewContent.length > 0) {
    const splitTextInstances = [];
    const scrollTriggerInstances = [];
    const initSplitReveal = () => {
      function setupSplit(el) {
        const splitParent = new SplitText(el, {
          type: 'lines',
          linesClass: 'split'
        });

        const splitChild = new SplitText(splitParent.lines, {
          type: 'lines',
          linesClass: 'line'
        });

        splitTextInstances.push(splitChild, splitParent);

        return splitChild.lines;
      }

      // Split
      splitContent.forEach((item) => {
        gsap.set(item, { visibility: 'visible' });
        const lines = setupSplit(item);
        const scrollTrigger = revealUp(lines, item);
        scrollTriggerInstances.push(scrollTrigger);
      });

      // Split + Skew
      splitSkewContent.forEach((item) => {
        gsap.set(item, { visibility: 'visible' });
        const lines = setupSplit(item);
        const scrollTrigger = revealSkew(lines, item);
        scrollTriggerInstances.push(scrollTrigger);
      });
    };
    initSplitReveal();

    const handleResize = () => {
      splitTextInstances.forEach((split) => {
        split.revert();
      });

      scrollTriggerInstances.forEach((scrollTrigger) => {
        scrollTrigger.kill();
      });

      initSplitReveal();
      highlight();
    };

    window.addEventListener('resize', debounce(() => {
      // Check if window width has changed to prevent resize firing on scroll for iOS.
      if (window.innerWidth !== windowWidth) {
        handleResize();
      }
    }));
  }
};

export default splitReveal;
